class Brand {

	constructor (params) {
		// Init variables
		this.$cache       = {};
		this.$cache.main  = params.target;
		
		this.current = false;
		
		// Trigger init functions
		this.initCache();
		this.initEventConst();
		this.registerEvents();
	}

	initCache() {
		this.$cache.left = this.$cache.main.find('.bi-left');
		this.$cache.fragrances = this.$cache.left.find('.fragrances');
		this.$cache.fragrancesImgMb = this.$cache.fragrances.find('.fragrances-images .img-wrapper');
		this.$cache.selectors = this.$cache.fragrances.find('.fragrances-selectors .selector');
		
		this.$cache.right = this.$cache.main.find('.bi-right');
		this.$cache.fragrancesImgDk = this.$cache.right.find('.bir-left .img-wrapper');
	}

	initEventConst() {
		this.onClickEvent = (e) => this.onClick(e);
	}

	registerEvents() {
		this.$cache.selectors.on('click', this.onClickEvent);
	}
	
	onClick(e) {
		let $el = $(e.currentTarget);
		let index = this.$cache.selectors.index($el);
		
		if(index !== this.current) {
			this.$cache.selectors.removeClass('is-active');
			$el.addClass('is-active');
			
			this.$cache.fragrancesImgMb.removeClass('is-current');
			this.$cache.fragrancesImgMb.eq(index).addClass('is-current');
			this.$cache.fragrancesImgDk.removeClass('is-current');
			this.$cache.fragrancesImgDk.eq(index).addClass('is-current');
		}
	}
}

export default Brand;


// WEBPACK FOOTER //
// ./scripts/components/brand.js